export type GenderCode = "male" | "female" ;

export const genderMap: Record<GenderCode, string> = {
    male: "남자",
    female: "여자",
  };